import { Button } from 'components/atoms';
import { useTranslation } from 'react-i18next';
import { PiFunnel } from 'react-icons/pi';
import {
  BUTTON_VARIANT,
  IButtonProps,
} from 'types/components/button/button.interface';
import { II18nextPrefix } from 'types/components/components.interface';
import { hasActiveFilterValues } from 'utils/global/object.utils';
import { getFilterSubmitLabel } from 'utils/global/translation.utils';
import './FormButtonFilter.scss';

interface IFormButtonFilterProps extends IButtonProps, II18nextPrefix {
  filters?: object | null;
}

const FormButtonFilter = ({
  i18nextPrefix,
  filters,
  wrapperClassNames,
  ...props
}: IFormButtonFilterProps) => {
  const { t } = useTranslation();
  const hasActiveFilters = hasActiveFilterValues(filters);

  return (
    <Button
      variant={BUTTON_VARIANT.submit}
      onlyIcon
      wrapperClassNames={`${wrapperClassNames ?? ''}${
        hasActiveFilters ? ' has-active-filters' : ''
      }`}
      {...props}>
      <Button.Description description={getFilterSubmitLabel(t, i18nextPrefix)} />
      <Button.Icon icon={<PiFunnel />} />
      {hasActiveFilters && <span className='filter-active-dot' />}
    </Button>
  );
};

export default FormButtonFilter;
